// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__c9RJb","inner":"Footer_inner__3oYQ8"};